import { useEffect, useRef, useState } from "react";

/**
 * Fires once when the element enters the viewport.
 * Adds `in-view` class so the CSS reveal classes trigger their transition.
 */
export function useReveal(options = { threshold: 0.15, rootMargin: "0px" }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      setInView(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.unobserve(node);
        }
      },
      options,
    );
    io.observe(node);
    return () => io.disconnect();
  }, [options]);

  return { ref, inView };
}
